import axios from 'axios';
import { app, router } from '../../main'; // import the instance

const baseDomain = (window as never)['baseUrl'];
const baseURL = `${baseDomain}/api`;

/**
 * Axios basic configuration
 * Some general configuration can be added like timeout, headers, params etc. More details can be found on https://github.com/axios/axios
 * */
const config = {
  baseURL,
  headers: {
    'accept-language': (window as never)['languageId'],
  },
};

/**
 * Creating the instance of Axios
 * It is because, in large scale application we may need to consume APIs from more than single server,
 * So, may need to create multiple http client with different config
 * Only this client will be used rather than axios in the application
 **/
const httpClient = axios.create(config);

/**
 * Auth interceptors
 * @description Configuration related to AUTH token can be done in interceptors.
 * Currenlty it is just doing nothing but idea to to show the capability of axios and its interceptors
 * In future, interceptors can be created into separate files and consumed into multiple http clients
 * @param {*} config
 */
const authInterceptor = (config: any) => {
  /** add auth token */
  return config;
};

const loggerInterceptor = (config: any) => {
  /** Add logging here */
  return config;
};

/** Adding the request interceptors */
httpClient.interceptors.request.use((config) => {
  if (app) {
    (app.config.globalProperties.$Progress as any).start(); // for every request start the progress
  }
  return config;
});
httpClient.interceptors.request.use(authInterceptor);
httpClient.interceptors.request.use(loggerInterceptor);

/** Adding the response interceptors */
httpClient.interceptors.response.use((response) => {
  if (app) {
    (app.config.globalProperties.$Progress as any).finish(); // finish when a response is received
  }
  return response;
});
httpClient.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error && error.response && error.response.status == 401) {
      router.push({ name: 'Login', query: { returnUrl: router.currentRoute.value.path } });
    }
    return Promise.reject(error);
  },
);

export { httpClient };
